export default __webpack_public_path__ + "static/media/30.3be93f06.jpg";